import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=770dd9be&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=js&"
export * from "./UserTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=770dd9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770dd9be",
  null
  
)

export default component.exports